import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { RouteLoading } from "../../app/route-boundaries.js";
import { useAuth } from "./auth-context.js";

export function PublicOnlyRoute({ children }: { readonly children: ReactNode }) {
  const auth = useAuth();
  if (auth.status === "loading") {
    return <RouteLoading />;
  }
  if (auth.status === "authenticated") {
    return <Navigate replace to={auth.organization === null ? "/onboarding" : "/"} />;
  }
  return children;
}

export function AuthenticatedRoute({ children }: { readonly children: ReactNode }) {
  const auth = useAuth();
  const location = useLocation();
  if (auth.status === "loading") {
    return <RouteLoading />;
  }
  if (auth.status === "anonymous") {
    return <Navigate replace state={{ from: location.pathname }} to="/login" />;
  }
  if (auth.organization === null) {
    return <Navigate replace to="/onboarding" />;
  }
  return children;
}

export function OnboardingRoute({ children }: { readonly children: ReactNode }) {
  const auth = useAuth();
  if (auth.status === "loading") {
    return <RouteLoading />;
  }
  if (auth.status === "anonymous") {
    return <Navigate replace to="/login" />;
  }
  if (auth.organization !== null) {
    return <Navigate replace to="/" />;
  }
  return children;
}
